/* Rough Old Glass – finish tabs on the panels & splashbacks calculator (Oct 2026).
   Groups come from product tags on the finishes in the calculator's finish collection:
   "Finish group: Most Popular", "Finish group: Classic Antiqued", "Finish group: Colour Tinted",
   "Finish group: Verre Églomisé", "Finish group: Textured Glass", "Finish group: Studio Collection".
   A finish can be in more than one group. Tabs with no finishes are hidden, so the Studio tab
   appears by itself once Studio finishes are tagged. */
(function () {
  if (!/\/pages\/bespoke-tiles/.test(location.pathname)) return;
  var TABS = [
    { id: 'Most Popular', label: 'Most popular' },
    { id: '*', label: 'All finishes' },
    { id: 'Classic Antiqued', label: 'Classic antiqued', heritage: true },
    { id: 'Colour Tinted', label: 'Colour tinted', heritage: true },
    { id: 'Verre Églomisé', label: 'Verre églomisé', heritage: true },
    { id: 'Textured Glass', label: 'Textured glass', heritage: true },
    { id: 'Studio Collection', label: 'Studio Collection' }
  ];
  var KEY = 'rogFinishTab', groups = null, current = null;

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function loadGroups() {
    var list = window.config && window.config.glassFinish && window.config.glassFinish.collection;
    if (!list || !list.length) return null;
    var map = {};
    list.forEach(function (p) {
      map[norm(p.title)] = (p.tags || []).filter(function (t) { return /^Finish group:/i.test(t); })
        .map(function (t) { return t.replace(/^Finish group:\s*/i, '').trim(); });
    });
    return map;
  }
  function inTab(title, tab) {
    if (tab === '*') return true;
    var g = groups[norm(title)] || [];
    return g.indexOf(tab) > -1;
  }
  function css() {
    if (document.getElementById('rog-ftabs-css')) return;
    var s = document.createElement('style'); s.id = 'rog-ftabs-css';
    s.textContent = '.rog-ftabs{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin:6px 0 18px}' +
      '.rog-ftabs button{border:1px solid #c9cdca;background:#fff;color:#3d4c4f;border-radius:20px;padding:7px 14px;font:inherit;font-size:14px;line-height:1.2;cursor:pointer}' +
      '.rog-ftabs button:hover{border-color:#3d4c4f}' +
      '.rog-ftabs button[aria-pressed="true"]{background:#3d4c4f;border-color:#3d4c4f;color:#fff}' +
      '.rog-ftabs .rog-ftabs-label{font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#8a8f93;margin-left:6px}' +
      '.rog-ftabs .rog-ftabs-sep{width:1px;height:22px;background:#d9d9d2;margin:0 4px}' +
      '@media (max-width:700px){.rog-ftabs{flex-wrap:nowrap;overflow-x:auto;padding-bottom:4px}.rog-ftabs button{white-space:nowrap}.rog-ftabs .rog-ftabs-label{white-space:nowrap}}';
    document.head.appendChild(s);
  }
  function counts(items) {
    var c = {};
    TABS.forEach(function (t) { c[t.id] = 0; });
    items.forEach(function (el) {
      var title = (el.querySelector('.bottom .title') || {}).textContent;
      TABS.forEach(function (t) { if (inTab(title, t.id)) c[t.id]++; });
    });
    return c;
  }
  function build(grid, items) {
    var c = counts(items), bar = document.createElement('div');
    bar.className = 'rog-ftabs'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Show finishes');
    var html = '', heritageShown = false, studio = '';
    TABS.forEach(function (t) {
      if (!c[t.id]) return;
      var b = '<button type="button" data-tab="' + t.id + '">' + t.label + '</button>';
      if (t.heritage) {
        if (!heritageShown) { html += '<span class="rog-ftabs-sep"></span><span class="rog-ftabs-label">Heritage</span>'; heritageShown = true; }
        html += b;
      } else if (t.id === 'Studio Collection') studio = '<span class="rog-ftabs-sep"></span>' + b;
      else html += b;
    });
    bar.innerHTML = html + studio;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-tab]'); if (!b) return;
      current = b.getAttribute('data-tab');
      try { sessionStorage.setItem(KEY, current); } catch (err) {}
      apply();
    });
    grid.parentNode.insertBefore(bar, grid);
    var saved = ''; try { saved = sessionStorage.getItem(KEY) || ''; } catch (err) {}
    current = (saved && c[saved]) ? saved : (c['Most Popular'] ? 'Most Popular' : '*');
  }
  function apply() {
    var grid = document.querySelector('.glass--finish .grid'), bar = document.querySelector('.rog-ftabs');
    if (!grid || !bar) return;
    grid.querySelectorAll('.frame-element').forEach(function (el) {
      var title = (el.querySelector('.bottom .title') || {}).textContent;
      var show = inTab(title, current);
      if ((el.style.display === 'none') === show) el.style.display = show ? '' : 'none';
    });
    bar.querySelectorAll('button[data-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tab') === current)); });
  }
  function tick() {
    var grid = document.querySelector('.glass--finish .grid');
    if (!grid) return;
    if (!groups) groups = loadGroups();
    if (!groups) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.frame-element'));
    if (!items.length) return;
    if (!document.querySelector('.rog-ftabs')) { css(); build(grid, items); }
    apply();
  }
  function start() {
    tick();
    var pending = false;
    try {
      new MutationObserver(function () {
        if (pending) return; pending = true;
        setTimeout(function () { pending = false; tick(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) { setInterval(tick, 800); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
